<div class="modal-header">
    @if (!meekijken) {
        <h3 class="modal-title">{{ 'MODALLOADMENU_TITLE' | translate }}</h3>
    }
    @if (meekijken) {
        <h3 class="modal-title">{{ 'MODALLOADMENU_WATCH_TITLE' | translate }}</h3>
    }
</div>
<div class="modal-body">
    <div class="mb-3">
        <input class="form-control"
               type="text"
               id="modelfilter"
               name="modelfilter"
               [(ngModel)]="filter"
               [placeholder]="'MODALLOADMENU_FILTER' | translate">
    </div>
    <div class="dl-model-loader-lijst">
        @for (model of gefilterdeModellen; track model.id) {
            <div class="dl-model-loader-item"
                 [class.dl-model-loader-item--actief]="geselecteerdModel === model"
                 [class.dl-model-loader-item--te-verwijderen]="teVerwijderenModel === model"
                 >
                @if (!meekijken) {
                    <div class="row">
                        <div class="col-sm-1">
                            <span class="fa-regular fa-trash-can dl-model-loader-verwijder-knop" [class.teverwijderen]="teVerwijderenModel === model"
                                  (click)="verwijderModel(model)"></span>
                        </div>
                        <div class="col-sm-11"
                             (click)="klikModel(model, false)"
                             (dblclick)="klikModel(model, true)">
                            <div class="row">
                                <div class="col-sm-8 overflow-x-hidden">
                                    {{ model.titel }}
                                    @if (model.owner) {
                                        <span>[{{ model.owner }}]</span>
                                    }
                                </div>
                                <div class="col-sm-4 text-end">
                                    {{ datumNaarNl(model.updatedAt) }}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (meekijken) {
                    <div class="row"
                         [class.dl-model-loader-item--live]="model.live"
                         (click)="klikModel(model, false)"
                         (dblclick)="klikModel(model, true)">
                        <div class="col-sm-4">
                            {{ model.owner }}
                            @if (model.chatnieuw) {
                                <sup><span class="fa-solid fa-comment-dots"></span></sup>
                            }
                        </div>
                        <div class="col-sm-8">{{ model.titel }}</div>
                    </div>
                }
            </div>
        }
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-info"
            [disabled]="!geselecteerdModel"
            (click)="laadModel()">
        {{ 'BTN_LOAD' | translate }}
    </button>
    <button class="btn btn-secondary" (click)="annuleer()">
        {{ 'BTN_CANCEL' | translate }}
    </button>
</div>
